import {
  Alert,
  Button,
  Calendar,
  Div,
  Dropdown,
  HeaderBack,
  ImageView,
  InputItem,
  Label,
  LoadingIndicator,
} from 'components';
import {Ecolors, Icons} from 'constant';
import React, {useRef, useState} from 'react';
import {StyleSheet} from 'react-native';
import {ScrollView} from 'react-native-gesture-handler';
import {useAppSelector} from 'store/hooks';
import {
  convertTimestamp,
  joinObjectCalendar,
  reJoinObjectCalendar,
} from 'utils';
import Comp from './Comp';
import {submitForm, validateData, validateDate} from './api';

const ChangeCMNDtoCCCDScreen = () => {
  const [photoAfter, setPhotoAfter] = useState<any>(null);
  const [loadingPhotoAfter, setLoadingPhotoAfter] = useState<boolean>(false);
  const [loadingPhotoBefore, setLoadingPhotoBefore] = useState<boolean>(false);
  const [photoBefore, setPhotoBefore] = useState<any>(null);
  const [placeOfIssue, setPlaceOfIssue] = useState<any>(null);
  const [idNo, setIdNo] = useState<string>('');
  const [dateOfIssue, setDateOfIssue] = useState<any>({
    date: '',
    month: '',
    year: '',
  });
  const [expireDateOfIdNo, setExpireDateOfIdNo] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);
  const refUpload = useRef<any>(null);

  const [isErrorIdno, setIsErrorIdno] = useState<boolean>(false);

  const currentUser = useAppSelector(state => state.authen.currentUser);

  const isValidateDOI = () => {
    const currentDate = convertTimestamp(new Date().toString()).split('/');
    const D = parseInt(currentDate[0]);
    const M = parseInt(currentDate[1]);
    const Y = parseInt(currentDate[2]);

    const dateOfIssueInt = parseInt(joinObjectCalendar(dateOfIssue));
    const currentDateInt = parseInt(
      joinObjectCalendar({
        date: D,
        month: M,
        year: Y,
      }),
    );

    if (dateOfIssueInt > currentDateInt) {
      Alert.showError({
        content: `accountverify.doiError`,
        onPress: () => {},
      });
      return false;
    }
    return true;
  };

  const onConfirm = async (base64Uri: string) => {
    return submitForm({
      base64Uri,
      idNo,
      dateOfIssue: dateOfIssue ? `${joinObjectCalendar(dateOfIssue)}` : '',
      expireDateOfIdNo: expireDateOfIdNo,
      placeOfIssue: placeOfIssue?.name,
      photoAfterURL: photoAfter?.url,
      photoBeforeURL: photoBefore?.url,
    });
  };

  return (
    <>
      <Comp
        ref={refUpload}
        setLoadingPhotoAfter={setLoadingPhotoAfter}
        setLoadingPhotoBefore={setLoadingPhotoBefore}
        setPhotoAfter={setPhotoAfter}
        setPhotoBefore={setPhotoBefore}
        setLoading={setLoading}
        onConfirm={base64Uri => {
          onConfirm(base64Uri);
        }}
      />
      <Div height={'100%'} backgroundColor={Ecolors.whiteColor}>
        <HeaderBack
          loading={false}
          titleRight={`accountverify.save`}
          type={2}
          onRightPress={() => {
            if (
              !validateData({placeOfIssue}, 'changecmnd.builongchonnoicap') ||
              !validateData({idNo}, 'changecmnd.giaytobatbuocnhap') ||
              !validateDate(
                {
                  date: dateOfIssue,
                  fromdate: new Date(currentUser.dob),
                  todate: new Date(),
                },
                'changecmnd.ngaycapbatbuocnhap',
              ) ||
              !validateData({photoBefore}, 'changecmnd.vuilongtaianh') ||
              !validateData({photoAfter}, 'changecmnd.vuilongtaianh') ||
              !isValidateDOI()
            ) {
              return;
            }
            if (idNo.length != 12) {
              Alert.showError({
                content: 'changecmnd.gioihan12so',
              });
              return;
            }
            // navigate('DigitalSignatureChangeCMNDScreen', {
            //   flowApp: 'ChangeCMNDtoCCCD',
            //   callback: file => {
            //     goBack().then(res => {
            //       onConfirm(file);
            //     });
            //   },
            // });
            // Keyboard.dismiss();
            refUpload.current.showUploadSign();
          }}
          title={`changecmnd.thaydoithongtin`}
        />
        <ScrollView keyboardShouldPersistTaps={'never'}>
          <Div>
            <Label
              marginTop={13}
              marginLeft={16}>{`accountverify.noicap`}</Label>

            <Dropdown
              multilanguage={true}
              url={`place-of-issue/load`}
              isActive={true}
              value={placeOfIssue}
              marginTop={13}
              paddingHorizontal={13}
              content={`changecmnd.builongchonnoicap`}
              onChange={a => {
                setPlaceOfIssue(a);
              }}
            />

            <Label
              marginTop={13}
              marginLeft={16}>{`accountverify.sohieugiayto`}</Label>
            <Div marginHorizontal={16}>
              <InputItem
                onChangeText={text => {
                  setIdNo(text);
                  if (isErrorIdno) {
                    setIsErrorIdno(false);
                  }
                }}
                value={idNo}
                isInput={true}
                maxLength={12}
                keyboardType="number-pad"
                marginHorizontal={0}
                onHandleChange={() => {
                  if (!!idNo && idNo?.length != 12) {
                    setIsErrorIdno(true);
                    return;
                  }
                }}
                marginTop={6}
                titleError="changecmnd.gioihan12so"
                isError={isErrorIdno}
              />
            </Div>
            <Label
              marginTop={13}
              marginLeft={16}>{`accountverify.ngaycap`}</Label>
            <Calendar
              initValue={reJoinObjectCalendar('')}
              onChange={(e: any) => {
                setDateOfIssue(e);
              }}
              defaultNumYear={30}
            />
            <Label
              marginTop={13}
              marginLeft={16}>{`changecmnd.hinhanhcccd`}</Label>
            <Div
              paddingHorizontal={16}
              paddingTop={20}
              flexDirection={'row'}
              alignItems={'center'}
              justifyContent={'space-between'}>
              <Button
                overflow={'hidden'}
                borderRadius={5}
                width={162}
                onPress={() => {
                  if (!loadingPhotoAfter && !loadingPhotoBefore) {
                    refUpload.current.showUploadImage('before');
                  }
                }}
                height={140}>
                <ImageView
                  borderRadius={5}
                  width={162}
                  height={140}
                  source={{
                    uri:
                      photoBefore?.base64Convert ||
                      photoBefore?.uri ||
                      photoBefore?.url,
                  }}
                />
                <Div
                  style={StyleSheet.absoluteFill}
                  alignItems={'center'}
                  justifyContent={'center'}
                  flex={1}
                  backgroundColor={Ecolors.transparentLoading}>
                  {loadingPhotoBefore ? (
                    <LoadingIndicator color={Ecolors.mainColor} />
                  ) : (
                    <ImageView
                      width={26}
                      height={24}
                      resizeMode={'contain'}
                      tintColor={Ecolors.whiteColor}
                      source={Icons.camera}
                    />
                  )}
                </Div>
              </Button>
              <Button
                overflow={'hidden'}
                borderRadius={5}
                width={162}
                onPress={() => {
                  if (!loadingPhotoAfter && !loadingPhotoBefore) {
                    refUpload.current.showUploadImage('after');
                  }
                }}
                height={140}>
                <ImageView
                  borderRadius={5}
                  width={162}
                  height={140}
                  source={{
                    uri:
                      photoAfter?.base64Convert ||
                      photoAfter?.uri ||
                      photoAfter?.url,
                  }}
                />
                <Div
                  style={StyleSheet.absoluteFill}
                  alignItems={'center'}
                  justifyContent={'center'}
                  flex={1}
                  backgroundColor={Ecolors.transparentLoading}>
                  {loadingPhotoAfter ? (
                    <LoadingIndicator color={Ecolors.mainColor} />
                  ) : (
                    <ImageView
                      width={26}
                      height={24}
                      resizeMode={'contain'}
                      tintColor={Ecolors.whiteColor}
                      source={Icons.camera}
                    />
                  )}
                </Div>
              </Button>
            </Div>
          </Div>
        </ScrollView>
      </Div>
    </>
  );
};

export default React.memo(ChangeCMNDtoCCCDScreen);
